import React from 'react';
import styled from '@emotion/native';
import { Expertise } from '@/shared/types/stylist';
import useExploreStore from '@/stores/useExploreStore';
import PreferenceButton from '@/shared/components/PreferenceButton';
import { Title } from './styledComponents';
import Spacer from '@/shared/components/Spacer';

const Container = styled.View({
  marginBottom: 32,
});

const ExpertiseFilters: React.FC = () => {
  const { filters, setFilters } = useExploreStore();

  const handleExpertiseChange = (expertise: Expertise) => {
    setFilters({
      expertise: filters.expertise.includes(expertise)
        ? filters.expertise.filter((e: Expertise) => e !== expertise)
        : [...filters.expertise, expertise],
    });
  };

  const handleShowAll = () => {
    setFilters({
      expertise: [],
    });
  };

  return (
    <Container>
      <Title>Areas of Expertise:</Title>
      <ButtonContainer>
        <PreferenceButton
          item="SHOW ALL"
          isSelected={filters.expertise.length === 0}
          isDesktop={false}
          onToggle={handleShowAll}
          buttonStyle={{
            marginBottom: 0,
          }}
          textStyle={{
            fontSize: 12,
          }}
        />
        {Object.values(Expertise).map((expertise) => (
          <PreferenceButton
            key={expertise}
            item={expertise}
            isSelected={filters.expertise.includes(expertise)}
            isDesktop={false}
            onToggle={() => handleExpertiseChange(expertise)}
            buttonStyle={{
              width: '48%',
              height: 62,
              marginBottom: 0,
              paddingHorizontal: 22,
            }}
            textStyle={{
              fontSize: 12,
            }}
          />
        ))}
      </ButtonContainer>
      <Spacer height={11} />
    </Container>
  );
};

const ButtonContainer = styled.View({
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'space-between',
  gap: 8,
});

export default ExpertiseFilters;
